import React from 'react';
import '../css/AuthButton.css';

const AuthButton = () => {
    return (
        <button className='get-started'>Get Started</button>
    )
}

export default AuthButton;